(ns practitest.frontend.components.users
  (:require [reagent.core :as reagent]
            ["react-select" :default Select :refer [components]]
            [clojure.string :as str]
            [practitest.frontend.components.lists :as lists]))

(defn find-user [users id]
  (first (filter #(and (= id (:id %))
                       (= "user" (:type %)))
                 users)))

(defn user-avatar
  [user]
  (when-let [avatar (:avatar user)]
    (case (:type avatar)
      "icon"
      (let [initials (str/join "" (map first (str/split (:name user) #" " 2)))]
        [:span.avatar-icon {:class (if (:certified user)
                                     "certified_circ"
                                     "noncertified_circ")}
         initials])

      "image"
      [:img.avatar-image {:src   (:url avatar)
                          :class (if (:certified user)
                                   "certified_circ"
                                   "noncertified_circ")}]

      ;default
      "")))

(def custom-option
  (fn [props]
    (let [user (.-data props)
          children (.-children props)]
      (reagent/as-element
        [:r> (.-Option components)
         props
         ;; Override children elements
         [user-avatar user]
         children]))))

(def custom-single-value
  (fn [props]
    (let [user (.-data props)
          children (.-children props)]
      (reagent/as-element
        [:r> (.-SingleValue components)
         props
         ;; Override children elements
         [user-avatar user]
         children]))))

(defn user-selector [{:keys [users-list
                             user]
                      :as   props}]
  [lists/objects-list (assoc props
                        :components #js {:Option      custom-option
                                         :SingleValue custom-single-value}
                        :label-fn (fn [user]
                                    (if (= "group" (:type user))
                                      (str "Group: " (:name user))
                                      (:name user)))
                        :value-fn (fn [user]
                                    (:id user))
                        :value user
                        :options users-list)])
